import httpClient from 'shared/lib/httpClient';
import { parseOrganizationList } from '../schemas/MasterDataSchema';

export const getOrganizationList = async (params, signal) => {
  const response = await httpClient.get('/organizations', { params, signal });
  return parseOrganizationList(response?.data);
};
